import logger from '../../logger';
import { getOwnerID, getOwnerJWT } from '../../utils/DryCookies';
import track from '../../utils/trackers';
import { dryFetch } from '../../utils/dryFetch';
import {
  hydrateAreasOfFocusClientDatabase,
  writeSystemValue,
} from '../offline';
import { getSelectedEntityID } from '../../utils/helpers';

// Fetch all areas of focus collections for a user
export const fetchAreasOfFocusCollectionsFromCloud = async () => {
  const ownerID = getOwnerID();
  const ownerJWT = getOwnerJWT();
  track.startTime('fetchAreasOfFocusCollections');
  const myHeaders = new Headers();
  myHeaders.append('Authorization', `Bearer ${ownerJWT}`);

  try {
    const areasOfFocusCollections = await dryFetch({
      name: 'fetchAreasOfFocusCollections',
      path: `/area-of-focus/collections/${ownerID}`,
    });

    const { results } = areasOfFocusCollections;

    let selectedCollection = null;
    let selectedNote = null;
    const completedTime = track.endTime('fetchAreasOfFocusCollections');
    logger.info(
      {
        ownerID,
        time: completedTime,
      },
      'fetchAreasOfFocusCollections time'
    );
    track.time({
      category: 'area_of_focus',
      name: 'fetch_areas_of_focus_collections',
      value: completedTime,
      label: '',
    });

    writeSystemValue({
      name: 'areasOfFocusCollectionLastSynced',
      utcDateTime: areasOfFocusCollections.utcDateTime,
    });

    results.forEach((element) => {
      if (element.default_area_of_focus_collection) {
        selectedCollection = element.area_of_focus_collection_id;
        selectedNote = element.selected_item;
      }
    });

    // Modify the format of the areas of focus collections
    // convert an array areas of focus collections into an object
    // with the key being the area of focus collection id
    // @todo - Fix the types
    const areasOfFocusCollectionsObject = {};
    results.forEach((element) => {
      areasOfFocusCollectionsObject[element.area_of_focus_collection_id] =
        element;
    });
    // const normalizedAreasOfFocusCollections = normalize(results, areasOfFocusCollectionsListSchema);

    // If there are areas of focus collections, then dispatch the receivedAreasOfFocusCollections action
    // and fetch the selected note
    if (
      areasOfFocusCollectionsObject?.entities?.areasOfFocusCollections &&
      Object.entries(
        areasOfFocusCollectionsObject?.entities?.areasOfFocusCollections
      )?.length
    ) {
      const selectedCollectionObject =
        areasOfFocusCollectionsObject.entities.areasOfFocusCollections[
          selectedCollection
        ];
      const selectedNoteID = getSelectedEntityID(selectedCollectionObject);
      // dispatch(receivedAreasOfFocusCollections(
      //   normalizedAreasOfFocusCollections,
      // ));
      // Save to app state

      // @todo Move this to an action on the area of focus state machine
      // if (selectedNoteID) {
      //   // dispatch(fetchNote(selectedNoteID));
      //   readNoteFromCloud(selectedNoteID);
      // }
    } else {
      // dispatch(receivedAreasOfFocusCollections(
      //   normalizedAreasOfFocusCollections,
      //   {},
      //   '',
      // ));
    }

    // Save to app state
    await hydrateAreasOfFocusClientDatabase({ areasOfFocus: results });
    return results;
  } catch (error) {
    logger.error(error);
    throw error;
  }
};

export const addNoteToAreaOfFocusCollection = async ({
  collectionId,
  noteId,
  isSelectedAreaOfFocus = false,
  selectedOnly = false,
  AOFObject = { order: null },
}) => {
  let bodyObject = {
    app_created_with: 'drynotes_web',
    selected: true,
    selected_only: selectedOnly,
  };

  if (AOFObject.order) {
    bodyObject.order = AOFObject.order;
  }

  try {
    const json = await dryFetch({
      name: 'addNoteToAreaOfFocusCollection',
      path: `/area-of-focus/collection/${collectionId}/entity/${noteId}`,
      options: {
        method: 'PUT',
        body: JSON.stringify(bodyObject),
      },
    });
    const collection = json.result;
    const selectedNoteId = getSelectedEntityID(collection);

    // dispatch(setAreaOfFocusCollectionState(collection, selectedNoteId));
    if (isSelectedAreaOfFocus) {
      // dispatch(updateSelectedAreasOfFocusCollection(collection));
      // dispatch(fetchAndSelectNote(selectedNoteId));
    }
    return json;
  } catch (error) {
    logger.error(error);
    throw error;
  }
};

export const removeNoteFromAreaOfFocusCollection = async ({
  collectionId,
  noteId,
}) => {
  try {
    const json = await dryFetch({
      name: 'removeNoteFromAreaOfFocusCollection',
      path: `/area-of-focus/collection/${collectionId}/entity/${noteId}`,
      options: {
        method: 'DELETE',
      },
    });
    return json;
  } catch (error) {
    logger.error(error);
    throw error;
  }
};

export const createAreaOfFocusCollection = async ({ title }) => {
  const ownerID = getOwnerID();
  try {
    const json = await dryFetch({
      name: 'createAreaOfFocusCollection',
      path: `/area-of-focus/collection`,
      options: {
        method: 'POST',
        body: JSON.stringify({
          title,
          owner_id: ownerID,
          app_created_with: 'drynotes_web',
        }),
      },
    });
    return json.result;
  } catch (error) {
    logger.error(error);
    throw error;
  }
};

export const renameAreaOfFocusCollection = async ({ collectionId, title }) => {
  try {
    const json = await dryFetch({
      name: 'renameAreaOfFocusCollection',
      path: `/area-of-focus/collection/${collectionId}`,
      options: {
        method: 'PUT',
        body: JSON.stringify({ title }),
      },
    });
    return json.result;
  } catch (error) {
    logger.error(error);
    throw error;
  }
};

export const deleteAreaOfFocusCollection = async ({ collectionId }) => {
  try {
    const json = await dryFetch({
      name: 'deleteAreaOfFocusCollection',
      path: `/area-of-focus/collection/${collectionId}`,
      options: {
        method: 'DELETE',
      },
    });
    return json;
  } catch (error) {
    logger.error(error);
    throw error;
  }
};
